import colorPicker from "./colorPicker.component";

const colorPickerModule = angular
  .module("app.components.colorPicker", [])
  .component("colorPicker", colorPicker);

export default colorPickerModule;



// WEBPACK FOOTER //
// ./src/components/colorPicker/colorPicker.module.js